import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";

import Carousel from 'react-bootstrap/Carousel';

import "aos/dist/aos.css"

import Aos from "aos";

function ProjectCards(props) {

  // console.log(props.index,"index")
  
  React.useEffect(() => {
    
    Aos.init({duration:3000})
  
    
  }, [])

  // 

  return (
    <Card data-aos={props.index%2===0 ?"fade-down":"fade-up"}  className="project-card-view " style={{borderRadius:"5px",display:"flex",padding:"20px",boxSizing:"border-box"}}>
      <div>
      <Carousel variant="dark" interval={1500} pause={false} >

      <Carousel.Item>
      
      <Card.Img variant="top" src={props.imgPath1} alt="card-img" />
      
      </Carousel.Item>

      <Carousel.Item>
      
      <Card.Img variant="top" src={props.imgPath2} alt="card-img" />
      
      </Carousel.Item>

      <Carousel.Item>
      
      <Card.Img variant="top" src={props.imgPath3} alt="card-img" />
      
      </Carousel.Item>

    </Carousel>
    </div>
    <div>
  
      <Card.Body >
        <Card.Title style={{fontWeight: "bold"}}>{props.title}</Card.Title>
        <Card.Text className="purple">Technology: {props.technologyUsed}</Card.Text>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <Button variant="primary" href={props.link} target="_blank" className="download-button">
          <BiLinkExternal /> &nbsp;
          {props.isBlog ? "View Project" : "View Project"}
        </Button>
        <Button variant="primary" href={props.git} target="_blank" className="download-button">
          <BiLinkExternal /> &nbsp;
          {props.isBlog ? "Git Hub" : "Git Hub"}
        </Button>
      </Card.Body>

      
      

      </div>
    </Card>
  );
}
export default ProjectCards;
